import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.updateTime()
    this.interval = setInterval(() => {
      this.updateTime()
    }, 1000)
  }

  updateTime() {
    const now = new Date();
    const finishHour = this.data.get("hour")
    const finishMin = this.data.get("min")
    const targetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(),  finishHour , finishMin);
    let restTime = targetTime - now

    let hours = Math.floor(restTime / 3600000).toString().padStart(2, '0')
    let minutes = Math.floor((restTime % 3600000) / 60000).toString().padStart(2, '0')
    let seconds = Math.floor((restTime % 60000)/1000).toString().padStart(2, '0')

    this.element.textContent = `${hours}:${minutes}:${seconds}`
  }

  disconnect() {
    clearInterval(this.interval)
  }
}